import type { MinigameDefinition } from '@core/types';

/**
 * Catalogo central de minijuegos. Cada modulo se registra aca con su definicion.
 * El hub consume este catalogo para construir el menu de forma dinamica, de modo
 * que agregar un minijuego nuevo NO requiere modificar la escena del hub.
 */
class MinigameRegistryImpl {
  private readonly minigames = new Map<string, MinigameDefinition>();

  public register(definition: MinigameDefinition): void {
    if (this.minigames.has(definition.key)) {
      console.warn(`El minijuego "${definition.key}" ya estaba registrado. Se ignora.`);
      return;
    }
    this.minigames.set(definition.key, definition);
  }

  public registerMany(definitions: MinigameDefinition[]): void {
    definitions.forEach((definition) => this.register(definition));
  }

  public list(): MinigameDefinition[] {
    return Array.from(this.minigames.values());
  }

  public get(key: string): MinigameDefinition | undefined {
    return this.minigames.get(key);
  }
}

/** Instancia compartida (singleton) del registry de minijuegos. */
export const MinigameRegistry = new MinigameRegistryImpl();
